export const OVERLAY_Z_INDEX = 10002;
export const SEARCH_BAR_Z_INDEX = 10003;
export const SEARCH_SUGGESTIONS_Z_INDEX = 9999;
export const AUTO_LOGOUT_BANNER_Z_INDEX = 1999;
export const MODAL_Z_INDEX = 2000;
export const DRAWER_CLOSE_BUTTON_Z_INDEX = 2;
export const BACKDROP_Z_INDEX = 1500;
export const GO_TO_TOP_Z_INDEX = 50;
export const BASE_Z_INDEX = 0;
export const NEGATIVE_BASE_Z_INDEX = -1;
export const STICKY_CONTAINER_BOTTOM_Z_INDEX = 1000;
export const SNACKBAR_Z_INDEX = 1001;
export const SIDE_NAV_HEADER = 1;
export const YOUTUBE_IFRAME_OVERLAY_ICON = 1;
export const LEGAL_DISCLAIMER_BANNER_Z_INDEX = 2;
export const FIXED_HOMECLUB_CTA_CONTAINER = 99;
export const CAROUSEL_CONTROL_Z_INDEX = 2;
export const FOCUS_OUTLINE_Z_INDEX = 2;
export const TOOLTIP_CONTAINER_BOTTOM_Z_INDEX = 1001;
export const PDP_PRODUCT_GALLERY_Z_INDEX = 1020;
export const ADD_TO_CART_STICKY_CONTAINER_Z_INDEX = 2;
